// extracted by mini-css-extract-plugin
export default {"success":"StatusesColor_success__36Avv","alert":"StatusesColor_alert__3JE4V","error":"StatusesColor_error__2gNI6","default":"StatusesColor_default__16wwS"};